module.exports = __webpack_public_path__ + "media/images/app/occasions/wedding-cbe0f0351506998f0e1dd21a5e60bdf3.webp";